import React, {JSX} from 'react';
import classNames from 'classnames';
import { Link } from "react-router-dom";

import {BooksIcon, LockedIcon, PaperIcon, PenIcon} from "../../assets/icons";

import { LessonItemType } from "./LessonItem.type";

import './styles.scss';

export const LessonItem: React.FC<LessonItemType> = ({
  isUnlocked,
  type,
  activityType,
  id,
  status,
  activities,
  lessons,
}) => {
  const lessonIcons: Record<'learn' | 'practice' | 'story', JSX.Element> = {
    learn: <PenIcon className="LessonIcon"/>,
    practice: <BooksIcon className="LessonIcon"/>,
    story: <PaperIcon className="LessonIcon"/>,
  }

  const activityPath = !!activities?.length ? `${type}/${activities[0].id}` : '';
  // const activityPath = !!activities.length ? `${type}` : '';

  return (
    <div className={classNames("LessonItem", {
      "isLocked": !isUnlocked,
      "inProgress": status === 'inprogress',
    })}>
      {!isUnlocked &&
        <div className="LockedIconWrapper">
          <LockedIcon className="LockedIcon"/>
        </div>
      }
      <Link
        // to="/topic/land-nature/learn"
        to={activityPath}
        onClick={e => !isUnlocked && e.preventDefault()}
        state={{ lessons, activities, type, activityType }}
      >
        {lessonIcons[type]}
      </Link>
    </div>
  );
};
